export const JOIN = "/join/:code?";
export const LOGIN = "/login";
export const HOME = "/";
export const PROFILE = "/profile/:type";
export const SETTINGS = "/settings/:type?/:paymentStatus?";
export const APPROVE_USERS = "/approve-users";
export const ACTIVATE = "/activate-:type/:code";
export const RESET_PASSWORD = "/reset-password/:code";
export const FORGOT_PASSWORD = "/forgot-password";
export const MEMBER_PROFILE = "/member/:slug";
export const MESSAGES = "/messages";
export const SEARCH = "/search";
export const FLIRTS = "/flirts";
export const UPGRADE = "/upgrade";
export const PROMO_UPGRADE = "/promo-upgrade";
export const MAGNET = "/magnet";
export const SETTING_MAGNET = "/settings/magnets";
export const SETTING_PASS = "/settings/superior-passes";
export const LAST_2_WEEKS = "/last-2-weeks-users";
export const PROMO_CODE_REQUESTS = "/promo-code-requests";
export const SUBSCRIBE = "/subscribe";



// WEBPACK FOOTER //
// ./src/constants/routes.js